// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { hideLoadingOverlay } from "@adl/App/Components/Common/XngLoadingOverlay";
import { mobileTippyStyle } from "@adl/App/Components/Tippy/Style";
import { xBaseTheme } from "@adl/XDL/types";
import { styledScrollbar, xScreen } from "@adl/XDL/Utilities";
import { css } from "styled-components";

export default {
    css: css`
        ${hideLoadingOverlay}
        ${mobileTippyStyle}
        body {
            ${styledScrollbar(8)}
        }
        ${xScreen("lte","xs")} {
            div:has(header#header-page):not(#react-app):not(data-test-selector="page_CheckoutShippingPage") {
                padding-top: 145px;
            }
            div[data-test-selector="page_CheckoutShippingPage"]:has(header#header-page) {
                padding-top: 72px;
            }
        }
    `,
} as xBaseTheme["globalStyle"];
